import * as React from 'react';
import Field from '@lendi-ui/field';
import { Input, InputProp } from '@lendi-ui/text-input';

import { EventTracking } from '@funnels/types';

import { FieldLabel } from '../../_common/FieldLabel';
import { FieldWrapper } from '../../_common/style';
export interface TextInputFieldProps extends EventTracking, Omit<InputProp, 'name' | 'onChange'> {
  label?: string;
  subLabel?: string;
  isError?: boolean;
  isOptional?: boolean;
  onChange?: (value?: string) => void;
}

function TextInputField(props: TextInputFieldProps) {
  const { onChange, isOptional, label, subLabel, value, ...otherProps } = props;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(e.target.value);
    }
  }

  return (
    <FieldWrapper>
      <FieldLabel label={label} subLabel={subLabel} isOptional />
      <Field>
        <Input {...otherProps} size="md" value={value} onChange={handleChange} isFullWidth />
      </Field>
    </FieldWrapper>
  );
}

export default TextInputField;
